const remapOptions = (options = [], idKey = 'id', nameKey = 'name') => {
  return options.map((option) => ({
    id: option[idKey],
    name: option[nameKey],
  }))
}

export default remapOptions
